import BaseService from './base-service.js'

export default {
    // Get projects info for user
    getProjects({ userUuid, params }) {
        const resource = `/users/${userUuid}/projects`
        return BaseService.get(`${resource}`, {
            params,
        }).then(resp => resp.data)
    },
    // Get projects info for user
    getProject({ projectUuid }) {
        const resource = `/projects/${projectUuid}/`
        return BaseService.get(`${resource}`).then(resp => resp.data)
    },
    // Get projects secure info
    getProjectSecureInfo({ projectUuid }) {
        const resource = `/projects/${projectUuid}/secure-info`
        return BaseService.get(`${resource}`).then(resp => resp.data)
    },
    // Add new project
    createProject(data) {
        const resource = '/projects'
        return BaseService.post(`${resource}`, data).then(resp => resp.data)
    },
    // Delete project
    deleteProject({ userUuid }) {
        const resource = `/projects/${userUuid}`
        return BaseService.delete(`${resource}`).then(resp => resp.data)
    },
    // Update existing project
    updateProject({ projectUuid, data }) {
        const resource = `/projects/${projectUuid}`
        return BaseService.put(`${resource}`, data).then(resp => resp.data)
    },
}
